import { render } from "./SendCrypto.vue?vue&type=template&id=65a8d3cb"
import script from "./SendCrypto.vue?vue&type=script&lang=js"
export * from "./SendCrypto.vue?vue&type=script&lang=js"
script.render = render

export default script